import { useMemo, useState, type ReactNode } from 'react';
import type { BreadcrumbItem } from '@/shared/ui/primitives';
import { BreadcrumbContext, type BreadcrumbContextValue } from './breadcrumb-context';

/**
 * Provides the breadcrumb trail shared between a workspace screen (which
 * publishes via `useSetBreadcrumb`) and the app shell top bar (which reads via
 * `useBreadcrumbItems`).
 */
export function BreadcrumbProvider({ children }: { children: ReactNode }): ReactNode {
  const [items, setItems] = useState<BreadcrumbItem[]>([]);
  const value = useMemo<BreadcrumbContextValue>(() => ({ items, setItems }), [items]);
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
}
